import React, { ChangeEvent } from "react";
import cn from "classnames";
import { CheckboxModes, Checkbox, CheckboxSize } from "@trussle/external-components";
import { IExampleSavingsOption, ISelectedExampleSavingsOption } from ".";

interface Props {
  setSelectedExampleSavingsOptions: any;
  selectedExampleSavingsOptions: ISelectedExampleSavingsOption[];
  exampleSavingsOptions: IExampleSavingsOption[];
}

export const SituationQuestions: React.FC<Props> = ({
  exampleSavingsOptions,
  selectedExampleSavingsOptions,
  setSelectedExampleSavingsOptions,
}) => {
  const handleSelectedExampleCheckboxPress = (event: ChangeEvent<Element>) => {
    const { id: targetID } = event.target;
    const selectedCount = selectedExampleSavingsOptions
      ? selectedExampleSavingsOptions.filter((option) => option.checked === true)
        .length
      : 0;
    const newExampleSavingsOptionsSelection = selectedExampleSavingsOptions
      && selectedExampleSavingsOptions.map((selectedExampleSavingsOption) => {
        const idMatches = selectedExampleSavingsOption.id === targetID;
        const canUpdate = selectedCount < 4 || !!selectedExampleSavingsOption.checked;

        if (idMatches && canUpdate) {
          return {
            checked: !selectedExampleSavingsOption.checked,
            id: targetID,
          };
        }
        return selectedExampleSavingsOption;
      });
    setSelectedExampleSavingsOptions(newExampleSavingsOptionsSelection);
  };

  const checkedExampleSavingOptionCount = selectedExampleSavingsOptions?.filter(
    (option) => !!option.checked,
  ).length;

  return (
    <div className="exampleSavingsCriteria">
      <hr />
      <h3 className="exampleSavingsCriteria__title">
        What's your situation?
      </h3>
      <div className="exampleSavingsOptions">
        {exampleSavingsOptions.map((exampleSavingsOption) => {
          const {
            id: savingOptionId,
            criteria,
          } = exampleSavingsOption;
          const matchingSelectedExampleSavingsOption = selectedExampleSavingsOptions.find(
            (selectedExampleSavingsOption) =>
              selectedExampleSavingsOption.id === savingOptionId,
          );
          const isChecked = matchingSelectedExampleSavingsOption
            ? matchingSelectedExampleSavingsOption.checked
            : false;

          const exampleSavingsOptionClasses = cn(
            "exampleSavingsOption",
            {
              "exampleSavingsOption--inactive":
          !isChecked && checkedExampleSavingOptionCount === 4,
            },
          );
          return (
            <div
              className={exampleSavingsOptionClasses}
              key={savingOptionId}
            >
              <Checkbox
                id={savingOptionId}
                classOverrides={{
                  label: "exampleSavingsOption__label-v3",
                  box: "exampleSavingsOption__box-v3",
                }}
                sizeBox={CheckboxSize.Small}
                mode={CheckboxModes.LightV3}
                checked={isChecked}
                label={criteria}
                onChange={handleSelectedExampleCheckboxPress}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
